import { render, staticRenderFns } from "./klabeledicon.vue?vue&type=template&id=af05e5d4&scoped=true"
import script from "./klabeledicon.vue?vue&type=script&lang=js"
export * from "./klabeledicon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af05e5d4",
  null
  
)

export default component.exports